import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Button, Stack } from '@mui/material';
import { Label, formatMessage } from 'cw-ui-core';
import RenderIfHasPermissions from 'src/components/RenderIfHasPermissions/RenderIfHasPermissions';
import { checkIfUserHaveGivenPermissions } from 'src/util/Util';
import { PERMISSIONS } from 'src/constants';
import Locale from 'src/i18n';
import css from 'src/styles/App.scss';

function AppBanner(props) {
    const { openNotifications, numberOfUsersNeedingApproval, onUsersApprovalButtonClick, notificationCount } = props;
    const hasNotificationPermission = checkIfUserHaveGivenPermissions([PERMISSIONS.NOTIFICATION_ALL]);

    return (
        <div className={css.bannerContainer} data-testid="appBanner">
            <Label value={formatMessage(Locale.ssoAppTitle)} className={css.appTitle} />
            <Stack direction="row" spacing={1} mt={3}>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_APPROVAL_ALL]}>
                    {numberOfUsersNeedingApproval > 0 && (
                        <Button
                            variant="outlined"
                            color="tertiary"
                            data-testid="userNeedApprovalCount"
                            endIcon={<PeopleAltOutlinedIcon />}
                            onClick={onUsersApprovalButtonClick}>
                            {`${numberOfUsersNeedingApproval} ${formatMessage(Locale.usersNeedApproval)}`}
                        </Button>
                    )}
                </RenderIfHasPermissions>

                {hasNotificationPermission && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={openNotifications}
                        endIcon={<NotificationsNoneOutlinedIcon />}
                        data-testid="notificationsBtn">
                        {notificationCount} {formatMessage(Locale.NotificationBtn)}
                    </Button>
                )}
            </Stack>
        </div>
    );
}

export default AppBanner;
